import { render, staticRenderFns } from "./automaticDropdown-editor.vue?vue&type=template&id=82662fa2&scoped=true&"
import script from "./automaticDropdown-editor.vue?vue&type=script&lang=js&"
export * from "./automaticDropdown-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82662fa2",
  null
  
)

export default component.exports